<template>
	<ShowDetailRecord :tdStyle="{ padding: '4px' }" :columnName="'チェック結果'">
		<template v-slot:value>
			<template v-if="check_item.check_item_options.length">
				<!-- TODO: 要修正 -->
				<template v-if="check_item.data_type == 'boolean'">
					<v-radio-group v-model="valueIndex" row>
						<v-radio
							v-for="(item, index) in check_item.check_item_options"
							:key="index"
							:label="item.text"
							:value="index"
							class="pt-5"
							@click="setBooleanValue(index)"
						>
						</v-radio>
					</v-radio-group>
				</template>
				<template v-else-if="check_item.data_type == 'text'">
					<v-select
						:rules="[rules.required]"
						v-model="checkValue.value_text"
						:items="check_item.check_item_options"
						item-text="text"
						item-value="text"
						dense
						outlined
						class="pt-6"
					>
					</v-select>
				</template>
				<template v-else-if="check_item.data_type == 'string'">
					<v-select
						:rules="[rules.required]"
						v-model="checkValue.value_string"
						:items="check_item.check_item_options"
						item-text="text"
						item-value="text"
						dense
						outlined
						class="pt-6"
					>
					</v-select>
				</template>
				<template v-else-if="check_item.data_type == 'integer'">
					<v-select
						:rules="[rules.required]"
						v-model="checkValue.value_integer"
						:items="check_item.check_item_options"
						item-text="text"
						item-value="text"
						dense
						outlined
						class="pt-6"
					>
					</v-select>
				</template>
				<template v-else-if="check_item.data_type == 'float'">
					<v-select
						:rules="[rules.required]"
						v-model="checkValue.value_string"
						:items="check_item.check_item_options"
						item-text="text"
						item-value="text"
						dense
						outlined
						class="pt-6"
					>
					</v-select>
				</template>
			</template>
			<template v-else-if="check_item.data_type == 'text'">
				<v-textarea
					:rules="[rules.required]"
					dense
					outlined
					class="pt-6"
					v-model="checkValue.value_text"
				></v-textarea>
			</template>
			<template v-else-if="check_item.data_type == 'string'">
				<v-text-field
					:rules="[rules.required]"
					dense
					outlined
					class="pt-6"
					v-model="checkValue.value_string"
				></v-text-field>
			</template>
			<template v-else-if="check_item.data_type == 'integer'">
				<v-text-field
					hide-spin-buttons
					:rules="[rules.required, rules.moreThanZero]"
					type="number"
					dense
					outlined
					class="pt-6"
					v-model="checkValue.value_integer"
				></v-text-field>
			</template>
			<template v-else-if="check_item.data_type == 'float'"
				><v-text-field
					:rules="[rules.required, rules.moreThanZero]"
					dense
					outlined
					type="number"
					class="pt-6"
					step="0.1"
					v-model="checkValue.value_float"
				></v-text-field
			></template>
			<template v-else-if="check_item.data_type == 'boolean'">
				<v-checkbox class="mt-4" label="確認" v-model="checkValue.value_boolean" />
			</template>
			<template v-else-if="check_item.data_type == 'date'"
				><v-menu
					ref="menu"
					close-on-content-click
					transition="scale-transition"
					offset-y
					min-width="auto"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							:rules="[rules.required]"
							label="年/月/日"
							v-model="checkValue.value_date"
							outlined
							dense
							readonly
							v-bind="attrs"
							v-on="on"
							class="mt-4"
						/>
					</template>
					<v-date-picker v-model="checkValue.value_date" no-title scrollable locale="ja" /> </v-menu
			></template>
			<template v-else-if="check_item.data_type == 'time'"
				><v-select
					v-model="checkValue.value_time"
					:rules="[rules.required]"
					:items="timeOptions"
					label="時間"
					outlined
					dense
					class="time-select pt-6"
				></v-select
			></template>
			<template v-else-if="check_item.data_type == 'datetime'">
				<v-menu
					ref="menu"
					close-on-content-click
					transition="scale-transition"
					offset-y
					min-width="auto"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							:rules="[rules.required]"
							label="年/月/日"
							v-model="date"
							outlined
							dense
							readonly
							v-bind="attrs"
							v-on="on"
							class="mt-4"
						/>
					</template>
					<v-date-picker v-model="date" no-title scrollable locale="ja" />
				</v-menu>
				<v-select
					v-model="time"
					:readonly="!date"
					:hint="!date ? '先に日付を選択してください' : ''"
					:rules="[rules.required]"
					:items="timeOptions"
					@change="createDateTimeValue"
					label="時間"
					outlined
					dense
					class="time-select pt-2"
				></v-select>
			</template>
		</template>
	</ShowDetailRecord>
</template>

<script>
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		check_item: {
			type: null,
			required: false,
		},
		check_value: {
			type: null,
			required: false,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			common,
			rules,
			selectedTime: null,
			timeOptions: [],
			date: null,
			time: null,
		}
	},

	created() {
		this.generateTimeOptions()
	},

	computed: {
		checkValue: {
			get() {
				return this.check_value
			},
			set(val) {
				this.$emit("update:check_value", val)
			},
		},
		valueIndex: {
			get() {
				if (this.checkValue.value_boolean == true) {
					return 0
				} else if (this.checkValue.value_boolean == false) {
					return 1
				}
			},
			set(val) {
				this.$emit("update:valueIndex", val)
			},
		},
	},
	methods: {
		setBooleanValue(index) {
			if (index == 0) {
				this.checkValue.value_boolean = true
			} else if (index == 1) {
				this.checkValue.value_boolean = false
			}
		},

		generateTimeOptions() {
			for (let hour = 0; hour < 24; hour++) {
				for (let minute = 0; minute < 60; minute += 10) {
					const time = `${this.padZero(hour)}:${this.padZero(minute)}`
					this.timeOptions.push({ text: time, value: time })
				}
			}
		},
		padZero(num) {
			return num.toString().padStart(2, "0")
		},

		createDateTimeValue() {
			const date = this.date.split("T")[0]
			const time = this.time.substring(0, 5)
			const dateTimeValue = `${date}T${time}`
			this.checkValue.value_datetime = dateTimeValue
		},
	},
}
</script>

<style lang="scss" scoped>
.time-select {
	width: 250px;
}
</style>
